import ProjectLogos from './ProjectLogos'

export default ProjectLogos
